import React, { useContext, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLineChart } from '@fortawesome/free-solid-svg-icons';
import { Line } from 'react-chartjs-2';
import { DataContext } from '../contexts/DataContext';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Legend } from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Legend);

const CombinedTrafficReferenceTimeSeriesCard = () => {
  const { data, isLoading } = useContext(DataContext);
  const [granularity, setGranularity] = useState('month'); // 'day' or 'month'

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!data) {
    return <div>No data available</div>;
  }

  // Process the data based on selected granularity
  const processDate = (date) => {
    if (!date) { // This will catch both null and undefined
      return null;
    }
    return granularity === 'month'
      ? date.slice(0, 7) // yyyy-mm
      : date;            // yyyy-mm-dd
  };

  const createdDateCounts = {};
  const paidDateCounts = {};
  data.forEach(item => {
    const createdDateKey = processDate(item.dates_pedimento.created_pedimento_date);
    createdDateCounts[createdDateKey] = (createdDateCounts[createdDateKey] || new Set()).add(item.traffic_reference);

    const paidDate = item.dates_pedimento.paid_date;
    if (paidDate) {
      const paidDateKey = processDate(paidDate);
      paidDateCounts[paidDateKey] = (paidDateCounts[paidDateKey] || new Set()).add(item.traffic_reference);
    }
  });

  // Convert Sets to counts
  for (const date in createdDateCounts) {
    createdDateCounts[date] = createdDateCounts[date].size;
  }
  for (const date in paidDateCounts) {
    paidDateCounts[date] = paidDateCounts[date].size;
  }

  const chartData = {
    labels: Object.keys({...createdDateCounts, ...paidDateCounts}).sort(),
    datasets: [
      {
        label: `Created Traffic References (${granularity})`,
        data: Object.keys(createdDateCounts).sort().map(key => createdDateCounts[key]),
        borderColor: 'rgb(75, 192, 192)',
        backgroundColor: 'rgba(75, 192, 192, 0.2)',
        fill: true,
      },
      {
        label: `Paid Traffic References (${granularity})`,
        data: Object.keys(paidDateCounts).sort().map(key => paidDateCounts[key]),
        borderColor: 'rgb(255, 99, 132)',
        backgroundColor: 'rgba(255, 99, 132, 0.2)',
        fill: true,
      }
    ],
  };

  // Chart options
  const options = {
    scales: {
      y: {
        beginAtZero: true,
      },
    },
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom',
      },
    },
  };

  return (
    <div className="bg-white shadow rounded-lg p-4 w-full max-w-lg flex flex-col justify-between h-custom-card-big overflow-y-auto">
      <div className="mb-4 flex justify-between items-center">
        <h2 className="text-lg font-bold text-gray-800 flex items-center">
          <FontAwesomeIcon icon={faLineChart} className="text-blue-600 mr-2" />
          Combined Traffic Reference Time Series
        </h2>
        <select
          value={granularity}
          onChange={(e) => setGranularity(e.target.value)}
          className="border border-gray-300 rounded p-1"
        >
          <option value="day">Daily</option>
          <option value="month">Monthly</option>
        </select>
      </div>
      <div className="flex-grow relative h-full">
        <Line data={chartData} options={options} />
      </div>
    </div>
  );
};

export default CombinedTrafficReferenceTimeSeriesCard;
